import { render, staticRenderFns } from "./PaymentsReceived.vue?vue&type=template&id=056176e6&scoped=true"
import script from "./PaymentsReceived.vue?vue&type=script&lang=js"
export * from "./PaymentsReceived.vue?vue&type=script&lang=js"
import style0 from "./PaymentsReceived.vue?vue&type=style&index=0&id=056176e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056176e6",
  null
  
)

export default component.exports